import React from 'react';
import { Home, Users, Calendar, DollarSign, Menu, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MobileBottomNav = ({ view, setView }) => {
    const navigate = useNavigate();
    const navItems = [
        { id: 'overview', label: 'Home', icon: Home, action: () => setView('overview') },
        { id: 'manage-teams', label: 'Teams', icon: Users, action: () => setView('manage-teams') },
        { id: 'games-list', label: 'Games', icon: Calendar, action: () => setView('games-list') },
        { id: 'financial-dashboard', label: 'Money', icon: DollarSign, action: () => setView('financial-dashboard') },
        { id: 'player-view', label: 'Player', icon: User, action: () => navigate('/dashboard') },
        { id: 'club-settings', label: 'More', icon: Menu, action: () => setView('club-settings') },
    ];

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 md:hidden pb-safe">
            <div className="flex justify-around items-center h-16">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = view === item.id;

                    return (
                        <button
                            key={item.id}
                            onClick={item.action}
                            className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'
                                }`}
                        >
                            <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                            <span className="text-[10px] font-medium">{item.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default MobileBottomNav;
